var messages = require('../components/messages');

var helpers = {
    validateEmail: function(email) {
        var re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
        return re.test(email);
    },

    focusSequence: function(message, callback) {
        if (!message || !callback) return;

        messages.setFocus();
        setTimeout(function () {
            if (!messages.focused()) return;

            callback();
        }, this.calcSpeechDuration(message));
    },

    calcSpeechDuration: function (text) {
        if (!text) return;

        // 4.79 - average number chars in words
        // 130 - rate words per minute
        return text.length * (1 / ((4.79 * 130) / 60)) * 1000;
    },

    validatePONumber: function (po_number) {
        var re = /[^a-zA-Z0-9\-\_]/;
        return !re.test(po_number);
    }
};

module.exports = helpers;


//////////////////
// WEBPACK FOOTER
// ../textbookx/service/bulk_po/scripts/services/helpers.js
// module id = 7
// module chunks = 0